import { createAction } from 'typesafe-actions';

import { BsCenter } from 'shared/types/filters/geo';

export const changeBSCenterAction = createAction('filters/BSCenterChanged')<BsCenter>();
